  <select class="input minimal" (change)="addPurchasingOptionFilter($event)" [value]="SelectedOption">
    <option value="">All</option>
    <option [selected]="PurchasingOptionSelected(i)" *ngFor="let i of options" [value]="i.id">{{i.text}}</option>
  </select>